import React from 'react'
import { Link } from 'react-router-dom'


import '../Styles/Footer.css'
import { useStateValue } from '../Utils/StateProvider'

function Footer() {
    const [{ site }] = useStateValue()

    return (
        <footer>
            <nav>
                <div class="flex-box">
                    <a href="#">Feedback</a>
                    <a href="#">Meridian Safe Bank Community</a>
                    <a href="#">Security</a>
                    <a href="#">Privacy</a>
                    <a href="#">Legal</a>
                </div>
            </nav>
            <div class="footer-paragraphs">
                <p>
                    Meridian Safe Bank Inc. (NYSE: ACB) is a leading digital financial services company. Meridian Safe Bank, the company's direct banking subsidiary, offers an array of deposit and mortgage products and services. Meridian Safe Bank is a Member FDIC and <strong>Equal Housing Lender</strong> , NMLS ID 181005. Mortgage credit and collateral are subject to approval and additional terms and conditions apply. Programs, rates and terms and conditions are subject to change at any time without notice.
                </p>
                <p>
                    Securities products and services are offered through Meridian Safe Bank Invest Securities LLC, member <a href="#">FINRA</a> and <a href="#">SIPC</a> . <a href="#">View Security Disclosures</a>.
                </p>
                <p>
                    Advisory products and services are offered through Meridian Safe Bank Invest Advisors, Inc. an SEC registered investment advisor. <a href="#">View all Advisory disclosures</a>
                </p>
                <p>
                    Foreign exchange (Forex) products and services are offered to self-directed investors through Meridian Safe Bank Invest Forex LLC. <a href="#">NFA</a> Member (ID #0408077), who acts as an introducing broker to GAIN Capital Group, LLC ("GAIN Capital"), a registered FCM/RFED and NFA Member (ID #0339826). Forex accounts are held and maintained at GAIN Capital. Forex accounts are NOT PROTECTED by the SIPC. <a href="#">View all Forex disclosures </a>
                </p>
                <p>
                    Forex, options and other leveraged products involve significant risk of loss and may not be suitable for all investors. Products that are traded on margin carry a risk that you may lose more than your initial deposit.
                </p>
                <p>
                    Products offered by Meridian Safe Bank Invest Advisors, Meridian Safe Bank Invest Securities, and Meridian Safe Bank Invest Forex are <strong>NOT FDIC INSURED, NOT BANK GUARANTEED</strong>, and <strong>MAY LOSE VALUE</strong>.
                </p>
                <p>
                    App Store is a service mark of Apple Inc. Google Play is a trademark of Google Inc. Amazon Appstore is a trademark of Amazon.com, Inc., or its affiliates. Windows Store is a trademark of the Microsoft group of companies
                </p>
                <p>
                    Zelle and the Zelle related marks are wholly owned by Early Warning Services, LLC and are used herein under license.
                </p>
                <p>
                    MONEY® Magazine, Nov. 2018 ® 2018 Time Inc. MONEY® is a registered trademark of Time Inc. and is used under License. MONEY® and Time Inc. are not affiliated with, and do not endorse products or services of, Meridian Safe Bank Bank.
                </p>
            </div>
            <p>&copy;2025 rights reserved. {site.name}</p>
        </footer>
    )
}

export default Footer
